import { Event } from '../../types/event';

interface EventIdFormatterProps {
    children: Event['id'];
}

export default function EventIdFormatter(props: EventIdFormatterProps) {
    return <>#{`${props.children}`.padStart(8, '0')}</>;
}
